import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=aa839b8e&scoped=true"
import script from "./NoticeList.vue?vue&type=script&lang=js"
export * from "./NoticeList.vue?vue&type=script&lang=js"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=aa839b8e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa839b8e",
  null
  
)

export default component.exports